import { render } from "./usersList.vue?vue&type=template&id=cb673e7c"
import script from "./usersList.vue?vue&type=script&lang=js"
export * from "./usersList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__